import React from "react";
import { Skeleton, Typography } from "antd";
import NPSScoreBadge from "./NPSScoreBadge";
import NPSSegmentTag from "./NPSSegmentTag";
import { segmentFor } from "../constants/npsConstants";
import { formatRelativeTime } from "../utils/npsUtils";

const { Text } = Typography;

export const getResponseColumns = (registerScoreRef) => [
  {
    title: "Order",
    dataIndex: "suborder_id",
    key: "suborder_id",
    render: (suborderId) => <Text strong>{suborderId}</Text>,
  },
  {
    title: "Customer",
    dataIndex: "reviewer",
    key: "reviewer",
  },
  {
    title: "Score",
    dataIndex: "rating",
    key: "rating",
    // sorter: (a, b) => a.rating - b.rating,
    showSorterTooltip: false,
    render: (rating, record) => (
      <NPSScoreBadge score={rating} ref={(el) => registerScoreRef?.(record.id, el)} />
    ),
  },
  {
    title: "Segment",
    dataIndex: "rating",
    key: "segment",
    render: (rating) => <NPSSegmentTag segment={segmentFor(rating)} />,
  },
  {
    title: "Submitted",
    dataIndex: "created_at",
    key: "created_at",
    // sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    defaultSortOrder: "descend",
    showSorterTooltip: false,
    render: (date) => <Text type="secondary" style={{ fontSize: 13 }}>{formatRelativeTime(date)}</Text>,
  },
];

// Same column layout as getResponseColumns, but every cell renders a
// placeholder shaped like its real content, so the loading table doesn't
// jump around once data arrives.
export const getResponseSkeletonColumns = () => [
  {
    title: "Order",
    key: "skeleton-suborder_id",
    render: () => <Skeleton.Input size="small" active style={{ width: 120 }} />,
  },
  {
    title: "Customer",
    key: "skeleton-reviewer",
    render: () => <Skeleton.Input size="small" active style={{ width: 150 }} />,
  },
  {
    title: "Score",
    key: "skeleton-rating",
    render: () => (
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <Skeleton.Avatar size={26} shape="circle" active />
        <Skeleton.Input size="small" active style={{ width: 20 }} />
      </span>
    ),
  },
  {
    title: "Segment",
    key: "skeleton-segment",
    render: () => <Skeleton.Button size="small" shape="round" active style={{ width: 76 }} />,
  },
  {
    title: "Submitted",
    key: "skeleton-created_at",
    render: () => <Skeleton.Input size="small" active style={{ width: 90 }} />,
  },
];

export const getSkeletonRows = (count = 6) =>
  Array.from({ length: count }, (_, i) => ({ id: `skeleton-row-${i}` }));
